import { Skeleton, Stack } from '@mui/material';
import { Content } from '@prismicio/client';
import React from 'react';

import PromotionCard from 'components/@promotions/PromotionCard';

interface Props {
  promotions: Array<Content.PromotionsDocument>;
  isLoading: boolean;
}

const PromotionsList: React.FC<Props> = ({ promotions, isLoading }) => {
  if (isLoading) {
    return (
      <Stack gap={4}>
        {Array.from(Array(3)).map((_, index) => (
          <Skeleton key={index} variant="rounded" height={240} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack gap={4}>
      {promotions.map((promotion) => (
        <PromotionCard key={promotion.uid} promotion={promotion} />
      ))}
    </Stack>
  );
};

export default PromotionsList;
